import { Container, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CheckoutApiError, checkoutApi } from "../api/client";
import type { IntentStatus } from "../api/types";
import { StatusView } from "../components/StatusView";

type State =
  | { kind: "loading" }
  | { kind: "result"; status: IntentStatus; returnUrl: string | null }
  | { kind: "session_invalid" }
  | { kind: "network_error" };

export function ReturnPage() {
  const { publicToken } = useParams<{ publicToken: string }>();
  const [state, setState] = useState<State>({ kind: "loading" });

  useEffect(() => {
    if (!publicToken) {
      setState({ kind: "session_invalid" });
      return;
    }
    const ctrl = new AbortController();
    checkoutApi
      .getSession(publicToken, ctrl.signal)
      .then((session) => {
        // El status del intent verdadero lo da el backend en el GET del session si el provider notificó por webhook.
        // Para MVP usamos el status de la session: completed → approved, expired/cancelled → invalid.
        if (session.status === "completed") {
          setState({ kind: "result", status: "approved", returnUrl: session.returnUrl });
        } else if (session.status === "open") {
          setState({ kind: "result", status: "pending", returnUrl: session.returnUrl });
        } else {
          setState({ kind: "session_invalid" });
        }
      })
      .catch((err: CheckoutApiError) => {
        if (ctrl.signal.aborted) return;
        if (err.statusCode === 404) setState({ kind: "session_invalid" });
        else setState({ kind: "network_error" });
      });
    return () => ctrl.abort();
  }, [publicToken]);

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 2, sm: 6 } }}>
      <Paper elevation={3} sx={{ p: { xs: 3, sm: 5 } }}>
        {state.kind === "loading" ? (
          <StatusView status="pending" message="Verificando el resultado del pago…" />
        ) : state.kind === "session_invalid" ? (
          <StatusView status="session_invalid" />
        ) : state.kind === "network_error" ? (
          <StatusView status="network_error" />
        ) : (
          <StatusView
            status={state.status}
            secondaryAction={
              state.returnUrl
                ? { label: "Volver al comercio", href: state.returnUrl }
                : undefined
            }
          />
        )}
      </Paper>
    </Container>
  );
}
